import { FC, useEffect, useState } from 'react';
import { NativeSelect as MNativeSelect } from '@mantine/core';
import classNames from 'classnames';
import { ChevronDown } from '@geist-ui/icons';
import { ChevronUp } from '@geist-ui/icons';
import { useClickOutside } from '@mantine/hooks';

import './styles.scss';

interface ISelectData {
  value: string;
  label: string;
}

interface Props {
  label?: string;
  data: ISelectData[] | string[];
  placeholder?: string;
  value: string;
  onChange: (value: any) => void;
  className?: string;
  variant?: 'primary' | 'secondary';
  withBorder?: boolean;
  searchable?: boolean;
  sx?: any;
  icon?: React.ReactNode; 
}

const NativeSelect: FC<Props> = ({
  label,
  data,
  placeholder,
  value,
  onChange,
  className,
  variant = 'primary',
  withBorder = false,
  sx = {},
  icon,
  ...others
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useClickOutside(() => {
    setIsOpen(false);
  });

  const checkOpenState = (e: any): void => {
    if (e.key === ' ' || e.key === 'Enter') {
      setIsOpen(!isOpen);
    }
  };

  useEffect(() => {
    setIsOpen(false);
  }, [value]);

  return (
    <MNativeSelect
      tabIndex={0}
      className={classNames(className, 'custom_native_select', {
        secondary: variant === 'secondary',
        with_border: withBorder,
      })}
      onKeyDown={(e) => {
        checkOpenState(e);
      }}
      ref={ref}
      sx={sx}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={(e) => {
        onChange(e);
      }}
      onClick={(e) => {
        if (isOpen === false) {
          setIsOpen(!isOpen);
        }
      }}
      data={data}
      styles={{ rightSection: { pointerEvents: 'none' } }}
      rightSectionWidth={20}
      rightSection={isOpen ? <ChevronUp size={16} color="#5b5eff" /> : <ChevronDown size={16} color="#5b5eff" />}
      role="combobox"
      icon={icon}
      {...others}
    />
  );
};

export default NativeSelect;
